import { render, staticRenderFns } from "./AccountInfoButton.vue?vue&type=template&id=607b650d&"
import script from "./AccountInfoButton.vue?vue&type=script&lang=js&"
export * from "./AccountInfoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports